import { ResourceIndexView } from '@app/types/blackroom-api';

export type TransformedResourceIndexView = ResourceIndexView & {
  subRows?: ResourceIndexView[];
};

export function transformToNestedData(
  resources: TransformedResourceIndexView[],
): TransformedResourceIndexView[] {
  // Create a map of resources by their parent ID for quick lookup
  const resourcesByParentId = resources.reduce<
    Record<string, ResourceIndexView[]>
  >((acc, resource) => {
    const parentId = resource.parentId ?? 'root';
    if (!acc[parentId]) {
      acc[parentId] = [];
    }
    acc[parentId].push(resource);
    return acc;
  }, {});

  // Function to recursively build the tree
  const buildTree = (parentId: string | null): ResourceIndexView[] => {
    const children = resourcesByParentId[parentId ?? 'root'] ?? [];
    return children.map((child) => ({
      ...child,
      subRows: buildTree(child.id),
    }));
  };

  // Start building the tree from root level (parentId is null)
  return buildTree(null);
}
